import {
  keyBy,
} from "lodash-es";

const TARGETS = [
  {
    id: "_blank",
    label: "_HTML_TARGET_BLANK_",
  },
  {
    id: "_self",
    label: "_HTML_TARGET_SELF_",
  },
];

export default TARGETS;

export const targetsKeyById = keyBy(TARGETS, "id");
